import { Injectable } from '@angular/core';

const ACCESS_TOKEN_KEY = 'fresply.accessToken';
const REFRESH_TOKEN_KEY = 'fresply.refreshToken';

/**
 * Thin wrapper around localStorage for JWT access/refresh token storage.
 * Nothing else in the app should touch localStorage directly for auth tokens.
 */
@Injectable({
  providedIn: 'root'
})
export class TokenService {
  getAccessToken(): string | null {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  }

  getRefreshToken(): string | null {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  }

  setTokens(accessToken: string, refreshToken: string): void {
    localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  }

  clear(): void {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  }

  hasAccessToken(): boolean {
    return !!this.getAccessToken();
  }
}
